import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import styles from './CustomCursor.module.scss';

const CustomCursor: React.FC = () => {
  const cursorRef = useRef<HTMLDivElement>(null);
  const cursorDotRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    const cursorDot = cursorDotRef.current;
    
    if (!cursor || !cursorDot) return;

    // Use quickSetter for optimal performance (bypasses standard tweening engine for mousemoves)
    const setCursorX = gsap.quickSetter(cursor, 'x', 'px');
    const setCursorY = gsap.quickSetter(cursor, 'y', 'px');
    const setDotX = gsap.quickSetter(cursorDot, 'x', 'px');
    const setDotY = gsap.quickSetter(cursorDot, 'y', 'px');

    const handleMouseMove = (e: MouseEvent) => {
      // Small lag on the outer circle for smooth trailing effect
      gsap.to(cursor, {
        x: e.clientX,
        y: e.clientY,
        duration: 0.15,
        ease: 'power2.out'
      });
      
      // Instant snap on the inner dot
      setDotX(e.clientX);
      setDotY(e.clientY);
    };

    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Expand cursor on links or buttons
      if (
        target.tagName.toLowerCase() === 'a' ||
        target.tagName.toLowerCase() === 'button' ||
        target.closest('a') ||
        target.closest('button') ||
        target.classList.contains('hover-target')
      ) {
        gsap.to(cursor, { scale: 1.5, backgroundColor: 'rgba(255, 255, 255, 0.1)', duration: 0.2 });
        gsap.to(cursorDot, { scale: 0, duration: 0.2 });
      } else {
        gsap.to(cursor, { scale: 1, backgroundColor: 'transparent', duration: 0.2 });
        gsap.to(cursorDot, { scale: 1, duration: 0.2 });
      }
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handleMouseOver);

    // Hide native cursor globally
    document.body.style.cursor = 'none';

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handleMouseOver);
      document.body.style.cursor = 'auto';
    };
  }, []);

  return (
    <>
      <div ref={cursorRef} className={styles.cursorOuter}></div>
      <div ref={cursorDotRef} className={styles.cursorInner}></div>
    </>
  );
};

export default CustomCursor;
